import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
import { ReferralTypeEnum } from '../../../../shared/entity_datas/EntityDatas.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIUrlParameterNames } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { CustomLinkUtils } from '../ui_utils/CustomLinkUtils.ts';
export class ReferralProgramUtils {
    static async getReferralLinkForSharing() {
        var _ClientUserState_userState;
        await ClientUserState.requireUser();
        const userId = (_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.id;
        if (userId == undefined) throw new Error('Cannot get referral link without a userId');
        const isMobile = UIUtilsEjsVariables.isUserOnMobile;
        const referralType = isMobile ? ReferralTypeEnum.MobileShareReferralProgramStore : ReferralTypeEnum.WebShareReferralProgramStore;
        const linkText = `${window.location.origin}#${UIUrlParameterNames.ReferralInvitation}=${userId !== null && userId !== void 0 ? userId : ''}-${referralType}`;
        return linkText;
    }
    static async setUserReferrer(discordReferrerId, userReferrerId, referralTypeId) {
        const dataToSend = {
            referredByDiscordUserId: discordReferrerId,
            referredByUserId: userReferrerId,
            referralTypeId: referralTypeId
        };
        await UIAjaxWrapper.postRequestWhenReady(UIAPIEndpoints.apiSetUserReferrer(), undefined, dataToSend);
    }
    static async processReferralInvitation(parameter) {
        await ClientUserState.requireUser();
        const user = ClientUserState.userState;
        if (!user) return;
        const { referrer, referralType } = CustomLinkUtils.extractReferrerFromShareLink(parameter);
        await ReferralProgramUtils.setUserReferrer(undefined, referrer, referralType);
    }
}
